import { createReducer } from '@src/redux/helpers/createReducer';
import { TOGGLE_MY_ACCOUNT } from './constants';

const initialState = {
  isMyAccountOpen: false,
};

export const headerMenuReducer = createReducer(initialState, {
  [TOGGLE_MY_ACCOUNT]: (state, action) => {
    return {
      isMyAccountOpen: action.payload,
    };
  },
});
